var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '@base/LanguageProvider';
import { createDroppableId, DroppableType, parseDroppableId } from '@data/dragAndDrop/types';
import { Droppable } from 'react-beautiful-dnd';
import { CustomColumnType, TagType } from '@common/api';
import FSButton from '@components/FSButton';
import { useUpdateUserSettingsActions } from '@data/hooks/currentUser';
import { useTagContext } from '@data/tag/tagContext';
import { isTableTagJsonData } from '@data/tag/types';
import { Plus, ThreeDots } from '@shared/icons/icons';
import Tags from '@shared/tags/Tags';
import { BasicTitle, TagBadge } from '@styled/Basic';
import { FlexCol } from '@styled/FlexWrappers';
import { ModalCloseBtn } from '@styled/Modal';
import { MCEFooter, MCEHeader, MCERow, MCERowInfoLabel, MCERowInner, MCEWrap } from '@styled/ModelColumnEditor';
import { appColors } from '@styled/useTheme';
import { IoMdClose } from 'react-icons/io';
import ContextMenu from '@shared/contextmenu/ContextMenu';
import { ThreeStateCheckBox } from '@shared/input/CheckBox';
import Input from '@shared/input/Input';
import { useRootSheetRow, useSheetRowActions } from '../../data/sheetRow/sheetRowHooks';
import { useAuth } from '../../providers/AuthProvider';
export var ModelCustomColumnType;
(function (ModelCustomColumnType) {
    ModelCustomColumnType["Number"] = "NUMBER";
    ModelCustomColumnType["Table"] = "TABLE";
    ModelCustomColumnType["Property"] = "PROPERTY";
})(ModelCustomColumnType || (ModelCustomColumnType = {}));
function calculatePosition(toggleRect) {
    var style = {};
    if (toggleRect === undefined) {
        return style;
    }
    style.bottom = toggleRect.bottom - toggleRect.top + toggleRect.height;
    style.left = toggleRect.left;
    return style;
}
var initialEmptyColumn = {
    width: 100,
    readonly: false,
    name: null,
};
export function useCustomOutsideClick(ref, callback, disabled, useDisableOnPortalClick) {
    if (disabled === void 0) { disabled = false; }
    if (useDisableOnPortalClick === void 0) { useDisableOnPortalClick = false; }
    useEffect(function () {
        function handleClickOutside(event) {
            if (!disabled && ref && ref.current && !ref.current.contains(event.target)) {
                var disableOnPortalClick_1 = false;
                if (useDisableOnPortalClick) {
                    event.composedPath().forEach(function (el) {
                        var _a, _b, _c, _d, _e;
                        try {
                            if (((_a = el.className) === null || _a === void 0 ? void 0 : _a.includes('fs-modal-content')) ||
                                ((_b = el.className) === null || _b === void 0 ? void 0 : _b.includes('tag-sidebar')) ||
                                ((_c = el.className) === null || _c === void 0 ? void 0 : _c.includes('remove-custom-colum')) ||
                                ((_d = el.className) === null || _d === void 0 ? void 0 : _d.includes('menu-custom-colum')) ||
                                ((_e = el.className) === null || _e === void 0 ? void 0 : _e.includes('context-menu'))) {
                                disableOnPortalClick_1 = true;
                            }
                        }
                        catch (e) { }
                    });
                }
                if (!disableOnPortalClick_1) {
                    callback();
                }
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, disabled]);
}
export default function ModelColumnEditor() {
    var _this = this;
    var L = useLanguage().L;
    var userSettings = useAuth().settings;
    var toggleShowTagsSidebar = useUpdateUserSettingsActions().toggleShowTagsSidebar;
    var rootSheetRow = useRootSheetRow();
    var tagData = useTagContext().tagData;
    var editSheetRow = useSheetRowActions().editSheetRow;
    var _a = __read(useState(), 2), activeDropzone = _a[0], setActiveDropzone = _a[1];
    var cols = (rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.customColumns) || [];
    var colsContainer = useRef(null);
    var menuTriggerRef = useRef(null);
    var toggleRef = useRef(null);
    var _b = __read(useState(false), 2), show = _b[0], setShow = _b[1];
    var _c = __read(useState({}), 2), position = _c[0], setPosition = _c[1];
    useEffect(function () {
        var _a;
        setPosition(calculatePosition((_a = toggleRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()));
    }, [open]);
    var toggleColumnManager = function () {
        setShow(!show);
    };
    var activateDropzone = function (idx) {
        setActiveDropzone(idx);
        if (!userSettings.show_tags_sidebar) {
            toggleShowTagsSidebar(true);
        }
    };
    var droppableRef = useRef(null);
    useCustomOutsideClick(droppableRef, function () { return setActiveDropzone(null); }, false, true);
    var addNewColumn = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow)) return [3 /*break*/, 2];
                    cols.push(__assign({}, initialEmptyColumn));
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: cols }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    activateDropzone(cols.length - 1);
                    setTimeout(function () {
                        if (colsContainer.current) {
                            var scrollHeight = colsContainer.current.scrollHeight;
                            var height = colsContainer.current.clientHeight;
                            var maxScrollTop = scrollHeight - height;
                            colsContainer.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
                        }
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var clearAllColumns = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow)) return [3 /*break*/, 2];
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: [] }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getColTags = function (column) {
        if (column.type === CustomColumnType.Number) {
            var tags_1 = [];
            if (column.dimensionTagIds) {
                column.dimensionTagIds.forEach(function (tagId) {
                    var tag = tagData.tagById[tagId];
                    if (tag) {
                        tags_1.push(tag);
                    }
                });
            }
            var tag = column.accountTagId ? tagData.tagById[column.accountTagId] : null;
            if (tag) {
                tags_1.push(tag);
            }
            return tags_1;
        }
        else if (column.type === CustomColumnType.Table && !column.property) {
            var tag = column.tableTagId ? tagData.tagById[column.tableTagId] : null;
            return tag ? [tag] : [];
        }
        else {
            return [];
        }
    };
    var getColProperty = function (column) {
        if (column.property && typeof column.property === 'string') {
            var tableId = column.tableTagId;
            if (tableId && column.property) {
                var table = tagData.tagById[tableId];
                var headers = [];
                if (table && table.jsonData !== null && isTableTagJsonData(table.jsonData)) {
                    headers = table.jsonData.headers;
                }
                return headers.find(function (h) { return h.uniqueId === column.property; }) || null;
            }
        }
        return null;
    };
    var removeTag = function (tagId, colIdx) { return __awaiter(_this, void 0, void 0, function () {
        var col, tag, newCols;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    col = __assign({}, cols[colIdx]);
                    tag = tagData.tagById[tagId];
                    if (!col || !tag) {
                        return [2 /*return*/];
                    }
                    if (tag.type === TagType.Account) {
                        col.accountTagId = null;
                    }
                    if (tag.type === TagType.Dimension) {
                        col.dimensionTagIds = (_a = col.dimensionTagIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== tagId; });
                    }
                    if (tag.type === TagType.Table) {
                        col.tableTagId = null;
                    }
                    if (!col.accountTagId &&
                        !col.tableTagId &&
                        (!col.dimensionTagIds || col.dimensionTagIds.length === 0) &&
                        !col.property) {
                        col.type = CustomColumnType.Number;
                    }
                    if (!(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow)) return [3 /*break*/, 2];
                    newCols = __spreadArray([], __read(cols), false);
                    newCols[colIdx] = col;
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: newCols }))];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var removeProperty = function (colIdx) { return __awaiter(_this, void 0, void 0, function () {
        var col, newCols;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    col = __assign({}, cols[colIdx]);
                    if (!col) {
                        return [2 /*return*/];
                    }
                    delete col.property;
                    if (!(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow)) return [3 /*break*/, 2];
                    newCols = __spreadArray([], __read(cols), false);
                    newCols[colIdx] = col;
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: newCols }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var deleteColumn = function (cIdx) { return __awaiter(_this, void 0, void 0, function () {
        var newCols;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow)) return [3 /*break*/, 2];
                    newCols = __spreadArray([], __read(cols), false);
                    newCols.splice(cIdx, 1);
                    setActiveDropzone(null);
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: newCols }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var toggleReadonlyColumn = function (colIdx) { return __awaiter(_this, void 0, void 0, function () {
        var col, newCols;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    col = __assign({}, cols[colIdx]);
                    if (!col) {
                        return [2 /*return*/];
                    }
                    col.readonly = col.readonly ? false : true;
                    if (!(rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow)) return [3 /*break*/, 2];
                    newCols = __spreadArray([], __read(cols), false);
                    newCols[colIdx] = col;
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: newCols }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var updateColumnTitle = function (colIdx, newTitle) {
        var col = __assign({}, cols[colIdx]);
        if (!col) {
            return;
        }
        if (newTitle === col.name) {
            return;
        }
        col.name = newTitle;
        if (rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.sheetRow) {
            var newCols = __spreadArray([], __read(cols), false);
            newCols[colIdx] = col;
            editSheetRow(__assign(__assign({}, rootSheetRow.sheetRow), { customColumns: newCols }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FSButton, { ref: toggleRef, "$type": "tertiary", title: L('Column Manager'), style: { whiteSpace: 'nowrap' }, onClick: toggleColumnManager }),
        show ? (React.createElement(MCEWrap, { id: "mcewrap", style: __assign({ position: 'absolute' }, position) },
            React.createElement(MCEHeader, null,
                React.createElement(BasicTitle, null, L('Column Manager')),
                React.createElement(ModalCloseBtn, { type: "button", onClick: toggleColumnManager, "aria-label": "Close" },
                    React.createElement(IoMdClose, null))),
            cols.length === 0 ? (React.createElement(FlexCol, { style: { flexGrow: 1, alignItems: 'center', justifyContent: 'center' } },
                React.createElement(BasicTitle, { style: { fontSize: 22 } }, L('No Columns.')),
                React.createElement("p", { style: { color: appColors.neutral.w700, textAlign: 'center', padding: 15 } }, L('You can start by adding a new column element. From there use the sidebar to select and create custom columns.')),
                React.createElement(FSButton, { icon: Plus, "$type": "tertiary", title: L('New column'), style: { paddingLeft: 4 }, onClick: addNewColumn }))) : (React.createElement(FlexCol, { style: { flexGrow: 1, justifyContent: 'space-between' } },
                React.createElement("div", { ref: colsContainer, style: { maxHeight: 300, overflow: 'auto' } }, cols.map(function (c, cIdx) {
                    var _a;
                    var droppableId = createDroppableId({
                        type: DroppableType.ModelCustomColumn,
                        customColumnIndex: cIdx,
                        sheetRowId: (_a = rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.id) !== null && _a !== void 0 ? _a : -1, // use -1 when no cluster is selected
                    });
                    var isActive = cIdx === activeDropzone;
                    var tags = getColTags(c);
                    var property = getColProperty(c);
                    if (isActive) {
                        return (React.createElement(Droppable, { key: droppableId, droppableId: droppableId, ignoreContainerClipping: false }, function (provided, snapshot) {
                            var targetParsed = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.draggingOverWith)
                                ? parseDroppableId(snapshot.draggingOverWith)
                                : null;
                            var itemParsed = (targetParsed === null || targetParsed === void 0 ? void 0 : targetParsed.sourceDroppableId)
                                ? parseDroppableId(targetParsed.sourceDroppableId)
                                : null;
                            var isFromSidebar = (itemParsed && itemParsed.type === DroppableType.TagSidebar) ||
                                false;
                            var onColumnDragActive = snapshot.isDraggingOver && isFromSidebar;
                            return (React.createElement(MCERow, __assign({ ref: provided.innerRef }, provided.droppableProps, { "$active": isActive, "$isDraggingOver": onColumnDragActive }),
                                React.createElement(MCERowInner, { "$active": isActive, ref: droppableRef },
                                    tags.length > 0 ? (React.createElement(Tags, { key: "".concat(c.type), hideAddButton: true, tags: tags, remove: function (tagId) { return removeTag(tagId, cIdx); } })) : null,
                                    property ? (React.createElement(TagBadge, { className: "transparent" },
                                        property.name,
                                        React.createElement("span", { className: "remove", onClick: function () { return removeProperty(cIdx); } },
                                            React.createElement(IoMdClose, null)))) : null,
                                    tags.length === 0 && !property ? (React.createElement(MCERowInfoLabel, null, L('Drop elements...'))) : null),
                                React.createElement(FSButton, { ref: menuTriggerRef, className: "menu-custom-colum", "$type": "tertiary", icon: ThreeDots, style: { padding: '9px' } }),
                                React.createElement(ContextMenu, { items: [
                                        {
                                            Component: function (props) { return (React.createElement(ThreeStateCheckBox, { value: c.readonly || false, action: function () {
                                                    return toggleReadonlyColumn(cIdx);
                                                }, label: L(L('Readonly')), css: { width: '100%', paddingLeft: 10 }, labelStyle: { padding: '0px 8px' } })); },
                                        },
                                        {
                                            Component: function (props) { return (React.createElement(Input, __assign({}, props, { defaultValue: c.name || '', placeholder: L('Custom title'), onKeyDown: function (e) {
                                                    if (e.key === 'Enter') {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        updateColumnTitle(cIdx, e.currentTarget.value);
                                                    }
                                                }, style: { marginLeft: 0 } }))); },
                                        },
                                    ], triggerRefs: [
                                        { ref: menuTriggerRef, trigger: 'click' },
                                    ] }),
                                React.createElement(FSButton, { className: "remove-custom-colum", "$type": "tertiary", icon: IoMdClose, onClick: function () { return deleteColumn(cIdx); }, style: { padding: '9px', color: appColors.error.w500 } })));
                        }));
                    }
                    else {
                        return (React.createElement(MCERow, { key: droppableId, "$active": isActive, "$isDraggingOver": false, onClick: function () { return activateDropzone(cIdx); } },
                            React.createElement(MCERowInner, null,
                                tags.length > 0 && !property ? (React.createElement(Tags, { hideAddButton: true, canUpdate: false, tags: tags, remove: function (tagId) { return removeTag(tagId, cIdx); } })) : null,
                                property ? (React.createElement(TagBadge, { className: "property" }, property.name)) : null,
                                tags.length === 0 && !property ? (React.createElement(MCERowInfoLabel, null, L('Select row to drop elements.'))) : null)));
                    }
                })),
                React.createElement(MCEFooter, null,
                    React.createElement(FSButton, { icon: Plus, "$type": "tertiary", title: L('New column'), onClick: addNewColumn }),
                    React.createElement(FSButton, { "$type": "tertiary", title: L('Clear All'), onClick: clearAllColumns })))))) : null));
}
